import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { RealEstateData } from 'types'
import { Collapse } from 'react-bootstrap'
import { setConstructionStatusFilter, setLocationFilter } from '@slices/developmentsSlice'
import { RootState } from '@redux/store'
import useQueryDevelopments from '@hooks/useQueryDevelopments'

const Filters_5 = (props: {
  menu: boolean
  setMenu: any
  global_data: RealEstateData
  constructionStatusButtons?: {
    name: string
    value: number
  }[]
  locations?: (string | undefined)[]
}) => {
  const { menu, setMenu, constructionStatusButtons, locations, global_data } = props

  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(
    global_data.pageConfig.keys.tokko,
  )

  const dispatch = useDispatch()
  const constructionStatusFilter = useSelector(
    (state: RootState) => state.developments.constructionStatus,
  )

  const locationFilter = useSelector((state: RootState) => state.developments.location)

  const developmentFilters = useSelector((state: RootState) => state.developments)

  const [collapse_items, setCollapse_items] = useState({
    location: false,
    status: false,
  })

  const filteredDevelopments = React.useMemo(() => {
    if (!allDevelopmentsData) return []

    return allDevelopmentsData.filter((development) => {
      const statusMatch =
        developmentFilters.constructionStatus === 'VER TODOS' ||
        !developmentFilters.constructionStatus ||
        development.construction_status.toString().toLowerCase() ===
          developmentFilters.constructionStatus.toLowerCase()

      const locationMatch = !developmentFilters.location
        ? true
        : development?.location?.name
            ?.toLowerCase()
            .includes(developmentFilters.location.toLowerCase())

      return statusMatch && locationMatch
    })
  }, [allDevelopmentsData, developmentFilters])

  const closeFilterFunction = () => {
    document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
    if (document.getElementById('handler-bar') !== null) {
      document.getElementById('handler-bar')!.style.zIndex = '0'
    }

    return setMenu(false)
  }

  const cleanFilters = () => {
    dispatch(setLocationFilter(''))
    dispatch(setConstructionStatusFilter(''))
  }

  const handleLocationChange = (location: string) => {
    dispatch(setLocationFilter(location))
  }

  const handleStatusChange = (status: string) => {
    dispatch(setConstructionStatusFilter(status))
  }

  return constructionStatusButtons && locations ? (
    <aside
      id="filters"
      className={'filters-5 col-12 ' + (menu ? ' h-100 filterOn blur ' : '')}
    >
      <form className="filters-container  filter-form container">
        <div className="container-fluid">
          <div className="filters-header mt-3 d-flex flex-column justify-content-between align-items-start w-100">
            <div className="filter-border-bottom d-flex align-items-stretch justify-content-between w-100">
              <div className="end"></div>
              <div className="start d-lg-flex pt-lg-5 align-items-center justify-content-start">
                <div className="d-block">
                  <h2 className="me-lg-5">Filtros de búsqueda</h2>
                </div>
              </div>
              <div
                id="closeFilter"
                className="end"
              >
                <div
                  onClick={() => closeFilterFunction()}
                  className="filters-close mt-2 text-right justify-content-right algin-items-start"
                  style={{ cursor: 'pointer' }}
                >
                  <span className="d-block">
                    <i></i>
                    <i></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="current-filters w-100 mt-lg-4 mt-2 d-lg-flex align-items-center justify-content-between">
              {constructionStatusFilter && (
                <div
                  className={
                    'tag-button d-inline-flex align-items-center justify-content-center mb-3 '
                  }
                >
                  {constructionStatusFilter}
                </div>
              )}
              {locationFilter && (
                <div
                  className={
                    'tag-button d-inline-flex align-items-center justify-content-center mb-3 '
                  }
                >
                  {locationFilter}
                </div>
              )}
              <div>
                <a
                  className="btn btn-clean btn-primary cursor-pointer"
                  onClick={() => {
                    cleanFilters()
                  }}
                >
                  Limpiar filtros
                </a>
              </div>
            </div>
            <div
              className="filters-group w-100"
              id="status"
            >
              <h3
                className="mb-4 d-flex align-items-center justify-content-between cursor-pointer collapsed"
                aria-controls="collapse-status"
                aria-expanded={collapse_items.status}
                onClick={() =>
                  setCollapse_items({ ...collapse_items, status: !collapse_items.status })
                }
              >
                Estado de construcción{' '}
                <a
                  style={{ rotate: collapse_items.status ? '180deg' : '0deg' }}
                  className="icon-arrow-light text-right d-block"
                ></a>
              </h3>
              <div className="options">
                <Collapse in={collapse_items.status}>
                  <div
                    className="row pb-4"
                    id="collapse-status"
                  >
                    {constructionStatusButtons?.map((status, index) => (
                      <label
                        key={index}
                        className={'mb-1 option flex-input'}
                      >
                        <input
                          id=""
                          type="checkbox"
                          className="not-closer radio-custom"
                          name="status[]"
                          value={constructionStatusFilter}
                          onChange={() => handleStatusChange(status.name ?? '')}
                          checked={constructionStatusFilter.includes(status.name ?? '')}
                        />
                        <span className="not-closer  custom-input square my-0"></span>{' '}
                        {status?.name}
                      </label>
                    ))}
                  </div>
                </Collapse>
              </div>
            </div>
            <div
              className="filters-group w-100"
              id="location"
            >
              <h3
                className="mb-4 d-flex align-items-center justify-content-between cursor-pointer collapsed"
                aria-controls="collapse-location"
                aria-expanded={collapse_items.location}
                onClick={() =>
                  setCollapse_items({ ...collapse_items, location: !collapse_items.location })
                }
              >
                Ubicación{' '}
                <a
                  style={{ rotate: collapse_items.location ? '180deg' : '0deg' }}
                  className="icon-arrow-light text-right d-block"
                ></a>
              </h3>
              <div className="options">
                <Collapse in={collapse_items.location}>
                  <div
                    className="row pb-4"
                    id="collapse-location"
                  >
                    {locations?.map((location, index) => (
                      <label
                        key={index}
                        className={'mb-1 option flex-input'}
                      >
                        <input
                          id=""
                          type="checkbox"
                          className="not-closer radio-custom"
                          name="location[]"
                          onChange={() => handleLocationChange(location ?? '')}
                          checked={locationFilter.includes(location ?? '')}
                        />
                        <span className="not-closer  custom-input square my-0"></span> {location}
                      </label>
                    ))}
                  </div>
                </Collapse>
              </div>
            </div>

            <div className="bottom-results">
              <input
                disabled={filteredDevelopments?.length === 0}
                onClick={() => document.body.classList.remove('overflow-hidden') + setMenu(false)}
                className="mx-auto d-block btn btn-primary btn-resultados"
                value={
                  isLoading
                    ? 'Cargando...'
                    : (filteredDevelopments && filteredDevelopments?.length > 0 ? 'Ver ' : '') +
                      filteredDevelopments?.length +
                      ' resultados'
                }
              />
            </div>
          </div>
        </div>
      </form>
    </aside>
  ) : (
    ''
  )
}

export default Filters_5
